module.exports = __webpack_public_path__ + "static/media/medium-realistic.2ef83449.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vans/medium-realistic.png
// module id = 886
// module chunks = 0